/**
 * Workbench 内部事件
 * @internal
 */
var InternalEvent;
(function (InternalEvent) {
    InternalEvent["SchemaRead"] = "$SchemaRead";
    InternalEvent["MinorButtonsChanged"] = "$MinorButtonsChanged";
})(InternalEvent || (InternalEvent = {}));

export { InternalEvent };
//# sourceMappingURL=internal-event.js.map
